const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
/* eslint-disable @typescript-eslint/no-use-before-define */
import { getFindOwnPermissionsQueryOptions, mapUserPermissionType } from '@api*';
import { PendingComponent } from '@common';
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'i18next';
export const Route = createFileRoute('/_rootLayout')({
  beforeLoad: async ({
    context: {
      queryClient
    }
  }) => {
    const data = await queryClient.ensureQueryData(getFindOwnPermissionsQueryOptions());
    const permissions = data.data ? data.data.map(mapUserPermissionType) : [];
    return {
      permissions
    };
  },
  loader: async () => {
    return {
      crumb: t('NAVIGATION.HOME'),
      to: '/'
    };
  },
  // 💡 Catch any errors that occur during the loading process
  onError: ({
    error
  }) => {
    console.error(error);
  },
  // 💡 Catch any rendering errors
  onCatch: error => {
    console.error(error.message);
  },
  // 💡 Render an error message component instead of crashing the app
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  pendingComponent: PendingComponent,
  pendingMs: 1000,
  pendingMinMs: 500,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});